export class AdminUpdateUserAttributes {
    constructor(
        public userName?: string,
        public accountName?: string,
        public email?: string,
        public insuranceCompanyId?: string,
        public linkageType?: string,
        public roleType?: string,
    ) { }
}